
import { Post } from "../../classes"
const PostModule = {
  namespaced: true,
  state: {
    posts: [],
    post: null,
    limit: 5,
    noMoreData: false,
    seenUsers: []
  },
  mutations: {
    setPosts(state, posts) {
      state.posts = posts || []
    },
    setPost(state, post) {
      state.post = post
    },
    setSeenPostUser(state, seenUsers) {
      state.seenUsers = seenUsers
    },
    clearPosts(state) {
      state.noMoreData = false
      state.posts = []
    },
    clearPost(state) {
      state.post = null
    },
    clearSeenPostUser(state) {
      state.seenUsers = []
    },
    addPosts(state, posts, isFirst = false) {
      if (isFirst) {
        state.posts.unshift(posts)
      } else {
        state.posts = state.posts.concat(posts);
      }
    },
    setNoMoreData(state, value) {
      state.noMoreData = value
    },
  },
  actions: {
    createPost: async ({ commit }, formData) => {
      try {
        // commit("clearPosts")
        const post = await Post.createPost(formData)
        commit("addPosts", [post], true)
        // commit("setPosts", data)
        return post
      } catch (error) {
        throw error
      }
    },
    editPost: async ({ commit }, formData) => {
      try {
        commit("clearPost")
        const data = await Post.editPost(formData)
        commit("setPost", data)
        return data
      } catch (error) {
        throw error
      }
    },
    removedPost: async ({ commit }, postId) => {
      try {
        commit("clearPost")
        const data = await Post.removedPost(postId)
        commit("setPost", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getPosts: async ({ commit, state }, formData) => {
      try {
        commit("clearPosts")
        let posts = await Post.getPosts({ ...formData, limit: state.limit, skip: 0 })
        commit("setPosts", posts)
        if (posts.length < state.limit) commit("setNoMoreData", true)
        return posts
      } catch (error) {
        throw error
      }
    },
    fetchPosts: async ({ commit, state }, formData) => {
      try {
        // commit("clearPosts")
        let posts = await Post.getPosts({ ...formData, limit: state.limit, skip: state.posts.length })
        // commit("setPosts", data)
        commit("addPosts", posts)
        if (posts.length < state.limit) commit("setNoMoreData", true)
        return posts
      } catch (error) {
        throw error
      }
    },
    getPost: async ({ commit }, postId) => {
      try {
        commit("clearPost")
        let data = await Post.getPost(postId)
        commit("setPost", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getSeenPostUser: async ({ commit }, postId) => {
      try {
        commit("clearSeenPostUser")
        let data = await Post.getSeenPostUser(postId)
        commit("setSeenPostUser", data)
        return data
      } catch (error) {
        throw error
      }
    },
  },
  getters: {
    getPosts: (state) => state.posts,
    getPost: (state) => state.post,
    getNoMoreData: (state) => state.noMoreData,
    getSeenPostUser: (state) => state.seenUsers,
  },
};
export default PostModule;
